import classes from './style/card.module.css'
const Card = ({ img, title, content }) => {
    return (
        <div className={classes.card}>
            <div className={classes.imgbox}>
                <img src={img} alt="Project Layout" />
            </div>
            <div className={classes.content}>
                <h3>{title}</h3>
                <p className={classes.skillafter}> <p className={classes.pAfter}>{content}</p></p>
            </div>
        </div>
    )
}
export default Card
